import * as React from "react";
import { MediaQuery } from "@grandvisionhq/common";
import { useIntersectionObserver } from "@grandvisionhq/lib-utils-react";
import { useIntl } from "@grandvisionhq/state";
import { ActionButtons } from "../../../../components/modules/MiniCart/components/ActionButtons.js";
const ActionButtonsContainer = ({ links }) => {
  const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
  const { getLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      toCart: getLabel("cart.actions.goToCart"),
      toCheckout: getLabel("cart.actions.goToCheckout")
    }),
    [getLabel]
  );
  const [buttonsRef, buttonsInview] = useIntersectionObserver();
  const showStickyButtons = isSmallScreen && !buttonsInview;
  return /* @__PURE__ */ React.createElement(
    ActionButtons,
    {
      buttonsRef,
      isSmallScreen,
      labels,
      links,
      shouldShowStickyButtons: showStickyButtons
    }
  );
};
export {
  ActionButtonsContainer
};
//# sourceMappingURL=ActionButtonsContainer.js.map
